import PropTypes from 'prop-types';
import { useMemo } from 'react';

import Drawer from '@mui/material/Drawer';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// project imports
import DrawerHeader from './DrawerHeader';
import DrawerContent from './DrawerContent';
import MiniDrawerStyled from './MiniDrawerStyled';
import { DRAWER_WIDTH } from 'config';

import { handlerMobileDrawerOpen, useGetMenuMaster } from 'api/menu';

// ==============================|| MAIN LAYOUT - DRAWER ||============================== //

export default function MainDrawer({ window }) {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDesktopDrawerExpanded ?? true;
  const mobileDrawerOpen = menuMaster?.isMobileDrawerOpen ?? false;
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  // header content
  const drawerContent = useMemo(() => <DrawerContent />, []);
  const drawerHeader = useMemo(() => <DrawerHeader open={drawerOpen} />, [drawerOpen]);

  return (
    <Box component="nav" sx={{ flexShrink: { md: 0 }, zIndex: 1200 }} aria-label="mailbox folders">
      {downLG ? (
        <Drawer
          variant="temporary"
          open={mobileDrawerOpen}
          onClose={() => handlerMobileDrawerOpen(false)}
          ModalProps={{ keepMounted: true }}
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              borderRight: '1px solid',
              borderColor: 'divider',
              boxShadow: (theme) => theme.vars.customShadows.z8
            }
          }}
        >
          <Box
            sx={{
              width: DRAWER_WIDTH,
              height: '100%',
              overflow: 'hidden',
              bgcolor: 'background.paper',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <DrawerHeader open />
            {drawerContent}
          </Box>
        </Drawer>
      ) : (
        <MiniDrawerStyled variant="permanent" open={drawerOpen}>
          {drawerHeader}
          {drawerContent}
        </MiniDrawerStyled>
      )}
    </Box>
  );
}

MainDrawer.propTypes = { window: PropTypes.func };
